// extracted by mini-css-extract-plugin
export var cardBody = "style-mod--card-body--9649e";
export var cardImg = "style-mod--card-img--f3423";
export var cardTitle = "style-mod--card-title--024e1";
export var doubleSliders = "style-mod--double-sliders--a8793";
export var fImg = "style-mod--f-img--80fed";
export var fistSlider = "style-mod--fist-slider--dc2c9";
export var macBtn = "style-mod--mac-btn--0832a";
export var macTitle = "style-mod--mac-title--2f839";
export var mobAuthorBox = "style-mod--mob-author-box--39715";
export var mobAuthorContent = "style-mod--mob-author-content--5bb90";
export var mobIframe = "style-mod--mob-iframe--12de8";
export var mobQuoteBox = "style-mod--mob-quote-box--9be04";
export var mqbAuthor = "style-mod--mqb-author--93860";
export var mqbBtn = "style-mod--mqb-btn--0d411";
export var mqbContent = "style-mod--mqb-content--30686";
export var mqbQuote = "style-mod--mqb-quote--1e6bb";
export var scAuthor = "style-mod--sc-author--9422e";
export var scIframe = "style-mod--sc-iframe--b154c";
export var scTitle = "style-mod--sc-title--832cc";
export var secondSlider = "style-mod--second-slider--9c1ff";
export var sliderCard = "style-mod--slider-card--9fd85";
export var sliderContent = "style-mod--slider-content--3eb4f";
export var sliderImg = "style-mod--slider-img--86d3c";